import { fetchCore } from "../data/query.js";
import { useMenuAxios } from "../context/axios.js";
import { useQuery } from "@tanstack/react-query";
//#region src/modules/core/hooks/use-core-query.ts
var useCoreQuery = () => {
	const { instance } = useMenuAxios();
	return useQuery({
		queryKey: ["core"],
		queryFn: () => fetchCore(instance),
		refetchInterval: 6e4
	});
};
//#endregion
export { useCoreQuery };
